import Vue                    from 'vue'
import VueRouter              from 'vue-router'
import FicheImmo              from '../views/FicheImmo.vue'
import FicheOrganisme         from '../views/FicheOrganisme.vue'
import ficheEmploi            from '../views/FicheEmploi.vue'
import ListeImmo              from '../views/ListeImmo.vue'
import ListeOffreEmploi       from '../views/ListeOffreEmploi.vue'
import FormulaireCandidature  from '../views/FormulaireCandidature.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/listeimmo' }, //La vue par défaut est la liste des offres immo
  {
    name: 'ficheImmo',
    path: '/ficheimmo/:propId',
    component: FicheImmo,
    props: true
  },
  {
    name: 'ficheOrganisme',
    path: '/ficheorganisme/:propId',
    component: FicheOrganisme,
    props: true
  },
  {
    name: 'listeImmo',
    path: '/listeimmo',
    component: ListeImmo
  },
  {
    name: 'ficheEmploi',
    path: '/ficheemploi/:propId',
    component: ficheEmploi,
    props: true
  },
  {
    name: 'listeOffreEmploi',
    path: '/listeoffreemploi',
    component: ListeOffreEmploi
  },
  {
    name: 'formulaireCandidature',
    path: '/formulairecandidature',
    component: FormulaireCandidature
  }
]

const router = new VueRouter({
  routes,
  /**
   * A chaque changement d'écran, on positionne l'ascenseur correctement
   */
  scrollBehavior(to, from){
    //console.log('to:', to, 'from:', from)

    // Quand on vient de la liste immo pour afficher une fiche immo...
    if ((from.name == 'listeImmo') && (to.name == 'ficheImmo')){
      document.getElementById('app').scrollIntoView() // ... On se positionne en haut de l'écran
    }

    // Quand on vient de la liste organisme pour afficher une fiche organisme...
    if ((from.name == 'listeOrganisme') && (to.name == 'ficheOrganisme')){
      document.getElementById('app').scrollIntoView() // ... On se positionne en haut de l'écran
    }
  }
})

export default router
